export interface BaseResponse<T> {
  result?: T;
  error?: BaseResponseError;
}

export interface BaseResponseError {
  type: string;
  message: string;
  data: { [property: string]: any };
}

/**
 * Determines if an object is likely to be a BaseResponse.
 */
export function isBaseResponse(response: any): response is BaseResponse<any> {
  if (response == null || typeof(response) !== 'object') return false;
  return 'error' in response && 'result' in response;
}
